// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__23Tdb","Header":"style_Header__1FjtR","About":"style_About__wuDPT","Bigger":"style_Bigger__svhzp"};